import ArrayFieldItemTemplate from './ArrayFieldItemTemplate.jsx';
import ArrayFieldTemplate from './ArrayFieldTemplate.jsx';
import { AddButton, CopyButton, MoveDownButton, MoveUpButton, RemoveButton, SubmitButton } from './ButtonTemplates.jsx';
import FieldErrorTemplate from './FieldErrorTemplate.jsx';
import FieldTemplate from './FieldTemplate.jsx';
import ObjectFieldTemplate from './ObjectFieldTemplate.jsx';
import TitleField from './TitleField.jsx';
import BaseInputTemplate from './BaseInputTemplate.jsx';

// Everything not listed here (DescriptionFieldTemplate, FieldHelpTemplate,
// ErrorListTemplate, WrapIfAdditionalTemplate, GridTemplate, MultiSchemaFieldTemplate,
// OptionalDataControlsTemplate, CyclicSchemaExpandTemplate, and every non-string/select/
// checkbox widget) falls back to @rjsf/core's own plain, framework-agnostic defaults —
// none of them are exercised by this app's schemas today (see Device Configuration).
export const generateTemplates = () => ({
  ArrayFieldItemTemplate,
  ArrayFieldTemplate,
  BaseInputTemplate,
  ButtonTemplates: {
    AddButton,
    CopyButton,
    MoveDownButton,
    MoveUpButton,
    RemoveButton,
    SubmitButton,
  },
  FieldErrorTemplate,
  FieldTemplate,
  ObjectFieldTemplate,
  TitleFieldTemplate: TitleField,
});
